module.exports = __webpack_public_path__ + "static/media/lock.ba674b30.svg";